import React from "react";
import { Navbar, Container, NavbarBrand } from "reactstrap";
import PrivacyGuide from "../../assets/docs/Audit Innovation Tools_Privacy Statement_FY18_Final Version.docx";

const currentYear = new Date().getFullYear();

const Footer = () => (
  <div className="fixed-bottom">
    <Navbar color="dark" dark>
      <Container style={{ height: "20px" }}>
        <NavbarBrand>
          <div className="footerStyle">
            &copy; {currentYear}. All rights reserved. See
            <a
              style={{ color: "#0d6efd" }}
              target="_blank"
              rel="noreferrer"
              href="https://deloittenet.deloitte.com/system/pages/Use.aspx"
            >
              Terms Of Use
            </a>{" "}
            and{" "}
            <a
              style={{ color: "#0d6efd" }}
              target="_blank"
              rel="noreferrer"
              href={PrivacyGuide}
            >
              Privacy
            </a>{" "}
            for more information.
          </div>
        </NavbarBrand>
      </Container>
    </Navbar>
  </div>
);

export default Footer;
